module.exports = __webpack_public_path__ + "static/3_mobile-b037e3a84e495bebb23e4a04508a3610.jpg";